/* Mobile Scroll Position Memory */
(function() {
  if (window.innerWidth > 768) return;
  var STORAGE_KEY = 'ppu_scroll_pos';
  
  function saveScroll() {
    if (window.innerWidth > 768) return;
    var data = { path: window.location.pathname + window.location.search, y: window.scrollY, ts: Date.now() };
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch(e) {}
  }
  
  function restoreScroll() {
    if (window.innerWidth > 768) return;
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      var data = JSON.parse(raw);
      if (data.path === (window.location.pathname + window.location.search) && (Date.now() - data.ts) < 300000) {
        sessionStorage.removeItem(STORAGE_KEY);
        requestAnimationFrame(function() {
          setTimeout(function() { window.scrollTo(0, data.y); }, 100);
        });
      }
    } catch(e) {}
  }
  
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a');
    if (link && link.href && link.href.indexOf(window.location.origin) === 0) {
      saveScroll();
    }
  }, true);
  
  window.addEventListener('beforeunload', saveScroll);
  
  if (window.performance && window.performance.navigation && window.performance.navigation.type === 2) {
    restoreScroll();
  }
  window.addEventListener('pageshow', function(e) {
    if (e.persisted || (window.performance && window.performance.navigation && window.performance.navigation.type === 2)) {
      restoreScroll();
    } else {
      restoreScroll();
    }
  });
})();